import type { MouseEvent, ReactNode } from "react";

import { navigateToAppPath } from "../navigation";

export function WorkspaceLink({
  ariaCurrent,
  ariaLabel,
  children,
  className,
  href,
}: {
  ariaCurrent?: "page";
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
  href: string;
}) {
  function navigate(event: MouseEvent<HTMLAnchorElement>) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    navigateToAppPath(href);
  }

  return (
    <a
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
      className={className}
      href={href}
      onClick={navigate}
    >
      {children}
    </a>
  );
}
